import { settings } from "@/settings"
import { useAuth0 } from "@auth0/auth0-react"
import mixpanel from "mixpanel-browser"
import { Browser } from "@capacitor/browser"
import { LoadingMobileLogin } from "../Loading"
import { useNavigate } from "react-router"
import React from "react"

export default function Logout(): React.JSX.Element {
  const navigate = useNavigate()
  const { isLoading, isAuthenticated, logout } = useAuth0()

  if (settings.IS_NATIVE_APP) {
    const logoutUri = `com.getvibrato.mobile://${settings.AUTH0_DOMAIN}/capacitor/com.getvibrato.mobile/callback`

    console.log("Native App Logout URI", logoutUri)

    const doLogout = async () => {
      await logout({
        logoutParams: {
          returnTo: logoutUri
        },
        async openUrl(url) {
          // Redirect using Capacitor's Browser plugin
          await Browser.open({
            url,
            windowName: "_self"
          })
        }
      })
    }

    doLogout()

    if (!isLoading && !isAuthenticated) {
      navigate("/mobile")
    }

    return <LoadingMobileLogin isAuthenticated={true} />
  }

  let returnTo = "https://www.getvibrato.com"
  if (settings.SHOW_NATIVE_APP) {
    returnTo = `getvibratocom.https://${settings.VIBRATO_FRONTEND_HOST}/mobile`
    localStorage.clear()
  }

  console.log(`Logout: ${returnTo}`)

  mixpanel.reset()

  logout({ logoutParams: { returnTo } })

  return (
    <>
      <div />
    </>
  )
}
